import { Fragment } from 'react';
import { ValidateResponse } from '../Validator';
import { Text, useTheme } from '@fluentui/react';

interface ValidationErrorsProps {
    validationResponses: ValidateResponse[];
    color?: string;
}

export const ValidationErrors = (props: ValidationErrorsProps) => {
    const theme = useTheme();
    return (
        <Fragment>
            {props.validationResponses.map((res, index) => (
                <Text
                    styles={{
                        root: {
                            color: props?.color || theme.semanticColors.warningBackground,
                            // display: "block"
                        },
                    }}
                    variant="xLarge"
                    key={res.name}
                >
                    {res.reason}
                    {index < props.validationResponses.length - 1 && ', '}
                </Text>
            ))}
        </Fragment>
    );
};
